import { IntlShape } from "react-intl";

// PUR timestamps are server instants. A date-only document field is not midnight.
export const formatPurTimestamp = (intl: IntlShape, value: string): string => {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return intl.formatMessage({ id: "MEERP_UNKNOWN" });
  const day = new Date(`${value.slice(0, 10)}T00:00:00Z`);
  if (!Number.isFinite(day.getTime()) || day.toISOString().slice(0, 10) !== value.slice(0, 10)) return intl.formatMessage({ id: "MEERP_UNKNOWN" });
  const instant = new Date(value);
  if (!Number.isFinite(instant.getTime())) return intl.formatMessage({ id: "MEERP_UNKNOWN" });
  return intl.formatDate(instant, { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false, timeZone: "Asia/Bangkok" });
};

export const PUR_STATUS_LABELS = new Set([
  "DRAFT", "SUBMITTED", "PENDING_APPROVAL", "APPROVED", "PARTIALLY_ORDERED", "ORDERED",
  "PARTIALLY_RECEIVED", "TO_BILL", "TO_RECEIVE", "COMPLETED", "VERIFIED", "CANCELLED",
]);

export const purErrorMessageId = (error: unknown): string => {
  if (error instanceof Error && /^(Invalid PUR|PUR record|PUR list)/.test(error.message)) return "MEERP_INVALID_RESPONSE";
  const response = (error as { response?: { status?: number } } | null)?.response;
  if (response?.status === 401 || response?.status === 403) return "MEERP_FORBIDDEN";
  if (response?.status === 404) return "MEERP_UNAVAILABLE";
  return "MEERP_ERROR";
};
